
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
// models
import { MessageTemplate } from '../../entities/notification';
import { Message, MessageTypes, Campaign } from '../../entities/site';
// services
import AuthService from '../../services/auth';

// containter
import Loader from '../../containers/Loader';
import Modal from '../../containers/Modal';

interface TemplatesProps {
    open: boolean;
    campaignId: string;
    campaign: Campaign;
    onClose(tempate?: MessageTemplate): void;
}

const Templates: React.FC<TemplatesProps> = (props) => {

    const classes = useStyles({});
    const [loading, setLoading] = useState<boolean>(false);
    const [templates, setTemplates] = useState<MessageTemplate[]>([]);
    const [categoryTemplates, setCategoryTemplates] = useState<MessageTemplate[]>([]);
    const [message, setMessage] = useState<Message>({ message: '', messageType: MessageTypes.notification });


    const fetchTemplates = async () => {
        try {
            // fetch
            setLoading(true);

            // const templateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/templates/campaign/${props.campaignId}`);
            // setTemplates(templateRes.data);

            const categoryTemplateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/templates/category/${props.campaign.type}`);
            const responseTemplates = categoryTemplateRes.data.filter((t: MessageTemplate) => t.type === 'response');
            setCategoryTemplates(responseTemplates);
            
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }

    useEffect(() => {
        if (props.campaignId) {
            fetchTemplates();
        }
    }, [props.open]);

    return (
        <Modal
            open={props.open}
            title="Response Templates"
            onClose={props.onClose}
            message={message}
        >
            <Loader open={loading}>
                {/* <div>Campaign Templates</div>
                {templates.map((template: MessageTemplate, index: number) => (
                    <div key={`template-${index}`} className={classes.container} onClick={() => props.onClose(template)}>
                        <div className={classes.title}>{template.name}</div>
                        <div className={classes.description}>{template.description}</div>
                    </div>
                ))}
                { !templates.length && 
                    <div className={classes.response}>No campaign response templates</div>
                } */}
                <div>Campaign Category Templates</div>
                {categoryTemplates.map((template: MessageTemplate, index: number) => (
                    <div key={`template-${index}`} className={classes.container} onClick={() => props.onClose(template)}>
                        <div className={classes.title}>{template.name}</div>
                        <div className={classes.description}>{template.description}</div>
                    </div>
                ))}
                { !categoryTemplates.length && 
                    <div className={classes.response}>No campaign response templates</div>
                }
            </Loader>
        </Modal>
    );
};

export default Templates;

const useStyles = makeStyles(theme => ({
    container: {
        border: "1px solid #CCCCCC",
        cursor: 'pointer',
        marginBottom: 10,
        borderRadius: 4,
        padding: 10,
        '&:hover': {
            backgroundColor: '#F4F7FC'
        },
    },
    title: {
        fontSize: 16,
        color: '#00ABCA',
        fontWeight: "bold"
    },
    description: {
        fontSize: 14,
        color: "#333333",
    },
    response :{
        border: "1px solid #CCCCCC",
        fontSize: 14,
        padding: 10,
        marginBottom: 20,
        borderRadius: 4,
    }
}));


// WEBPACK FOOTER //
// ./src/components/campaign/Templates.tsx